module.exports = __webpack_public_path__ + "saira-bold-webfont.70fb1f9268d4bbd128de.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-bold-webfont.eot
// module id = ../../../../../src/assets/fonts/saira-bold-webfont.eot
// module chunks = styles